import { render } from "./OlapDeleteVersionsDialog.vue?vue&type=template&id=6cbae8f4&ts=true"
import script from "./OlapDeleteVersionsDialog.vue?vue&type=script&lang=ts"
export * from "./OlapDeleteVersionsDialog.vue?vue&type=script&lang=ts"

import "./OlapDeleteVersionsDialog.vue?vue&type=style&index=0&id=6cbae8f4&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__